module.exports = __webpack_public_path__ + "img/idcard2.09d33175.png";